import { IngredientDataType } from "../../../../config/enums/IngredientType.enum";
import { IngredientRowViewModel } from "../types/ingredientListView.types";

/**
 * Single-responsibility formatter for the "Climate Impact" cell.
 *
 * Mirrors `getClimateImpactMessage` from the legacy `IngredientList` (see
 * src/screens/ingredients/ingredientList/IngredientList.tsx) exactly — same
 * four branches, same copy — just isolated so it can be reused/tested
 * without dragging the whole grid component along.
 */
export class ClimateImpactFormatter {
  static format(row: IngredientRowViewModel, isUserSupplier: boolean): string {
    const climateImpact = row.supplierIngredientDetails?.climate_impact;
    const isSupplierData =
      row.supplierIngredientDetails?.data_type === IngredientDataType.SUPPLIER;

    if (climateImpact) {
      if (isUserSupplier) {
        return "Calculated: Upgrade to see results";
      }
      return climateImpact.toString().replace(/\s*kgCO2eq\s*$/, "");
    }

    return isSupplierData ? "Supplier information pending" : "Data collection in progress";
  }
}
